module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/JP-2a45dc42258c8eb130f56df20e1c1c8c.png";